import BaseModel from "../base_model.js";

class RawNoteModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "text",
        type: "text",
        multiline: true
      },
    ]
  }

  i18nScope() {
    return "model.content.note";
  }

}
const NoteModel = new RawNoteModel();

export { RawNoteModel, NoteModel }

